module.exports = __webpack_public_path__ + "img/member-1.ce2b8c6d.png";